var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPinWaypoint(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 56C31.8659 56 35 52.8661 35 49C35 45.1341 31.8659 42 28 42C24.1339 42 21 45.1341 21 49C21 52.8661 24.1339 56 28 56Z",
    fill: "#171B1F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 38C38.4933 38 47 29.4935 47 19.0001C47 8.50654 38.4933 0 28 0C17.5065 0 9 8.50654 9 19.0001C9 29.4935 17.5065 38 28 38Z",
    fill: "#3BD4AE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28 29C33.5224 29 38 24.5227 38 19.0001C38 13.4773 33.5224 9 28 9C22.4772 9 18 13.4773 18 19.0001C18 24.5227 22.4772 29 28 29Z",
    fill: "#FAFAFA"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinWaypoint);
export default __webpack_public_path__ + "static/media/pin-waypoint.8d09c3661246524d6a5c9ccec44237fb.svg";
export { ForwardRef as ReactComponent };